import { commonApi } from '@common/utils/baseQuery';
import config from '@config';
import { IGetExpressBonusesResponse } from '@features/bonus-express/api/bonusExpressApi.type';
import sortBy from 'lodash/sortBy';

export const bonusExpressApi = commonApi.injectEndpoints({
  endpoints: (builder) => ({
    getExpressBonuses: builder.query<IGetExpressBonusesResponse[], void>({
      query: () => `${config.host}/expressbonus`,
      transformResponse: (response: IGetExpressBonusesResponse[]) => {
        if (Array.isArray(response) && response.length) {
          return sortBy<IGetExpressBonusesResponse>(response, [ 'minItems', 'minOddRate' ]);
        }
        return [];
      }
    }),
    activateExpressBonus: builder.mutation<any, {betNo: any, expressBonusId: any }>({
      query: ({ betNo, expressBonusId }) => ({
        url: `${config.host}/expressbonus`,
        body: {
          betNo,
          expressBonusId,
        },
        method: 'POST'
      })
    })
  })
})


export const {
  useGetExpressBonusesQuery,
  useActivateExpressBonusMutation
  } = bonusExpressApi;
